import { PrimaryButton, SecondaryButton } from "../components/common";

export default function NotFound() {
  return (
    <section className="container-page flex min-h-[70vh] flex-col items-center justify-center py-20 text-center" data-testid="not-found">
      <span className="font-heading text-[80px] font-800 leading-none text-brand-primary/20 md:text-[120px]">404</span>
      <h1 className="mt-4 font-heading text-[30px] font-800 text-brand-ink md:text-[42px]">This page could not be documented.</h1>
      <p className="mt-4 max-w-lg text-[17px] text-brand-muted">The page may have moved, or the address may be incomplete.</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <PrimaryButton to="/" testid="notfound-home">Return Home</PrimaryButton>
        <SecondaryButton to="/services" testid="notfound-services">Explore Services</SecondaryButton>
      </div>
    </section>
  );
}
